import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
} from '@angular/core';
import { BaseComponent } from '@macs-frontend/core';
import { makeSelectable } from '@macs-frontend/decorators';
import { Store } from '@ngrx/store';
import { DimonaStatuses } from '@macs-frontend/features/shared';

@Component({
  selector: 'md-dimona-status-dot',
  templateUrl: 'dimona-status-dot.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['dimona-status-dot.component.scss'],
})
export class DimonaStatusDotComponent extends BaseComponent {
  @Input() status: DimonaStatuses | null = null;

  constructor(readonly cdr: ChangeDetectorRef, readonly store$: Store) {
    super();
    // makeSelectable(this, { cdr, store$ });
  }

  get colorClass() {
    if (this.status === DimonaStatuses.ACCEPTED) {
      return 'status-dot_green';
    } else if (this.status === DimonaStatuses.ERROR) {
      return 'status-dot_red';
    }
    return null;
  }

  get tooltipText() {
    if (this.status === DimonaStatuses.ACCEPTED) {
      return 'Dimona accepted';
    } else if (this.status === DimonaStatuses.ERROR) {
      return 'Dimona error';
    }
    return 'Pending Dimona';
  }
}
